<template>
  <div id="app">
    <!-- Render NavBar always (you can make this conditional if you want) -->
    <NavBar v-if="showNavBar" />

    <div class="main-content">
      <router-view v-slot="{ Component }">
        <transition name="fade" mode="out-in">
          <component :is="Component" />
        </transition>
      </router-view>
    </div>

    <!-- Global Notification Component -->
    <GlobalNotification />

    <!-- Floating Donation Button -->
    <FloatingCoffeeButton />
  </div>
</template>

<script>
import { computed } from "vue";
import NavBar from "@/components/NavBar.vue";
import GlobalNotification from "@/components/GlobalNotification.vue"; 
import FloatingCoffeeButton from "@/components/FloatingCoffeeButton.vue";

export default {
  name: "App",
  components: {
    NavBar,
    GlobalNotification,
    FloatingCoffeeButton,
  },
  setup() {
    // If you later need to hide the NavBar on specific routes, you can do so with Vue Router checks:
    const showNavBar = computed(() => true); // Right now, always true

    return {
      showNavBar,
    };
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap");

* {
  padding: 0;
  margin: 0;
  box-sizing: border-box; /* Add this to help with responsive sizing */
}

:root {
  /* Base font size helps scale text across devices */
  font-size: 16px;
  font-family: "Montserrat", "Avenir", "Arial", sans-serif;

  /* Theme variables */
  --text-primary: #b6b6b6;
  --text-secondary: #ececec;
  --bg-primary: #23232e;
  --bg-secondary: #141418;
}

body {
  /* Fall back to a solid color for older mobile browsers */
  background-color: var(--bg-primary);
  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.8)),
              url("./assets/img/knife2.webp");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  /* background-attachment: fixed can cause issues on mobile, 
     so we often remove or override it in media queries. */
  background-attachment: fixed;
  color: var(--text-primary);
  margin: 0;
  padding: 0;
  font-size: 1rem; /* relative to :root font-size */
  min-height: 100vh;
}

#app {
  min-height: 100vh;
}

/* Main content offset for NavBar */
.main-content {
  padding-top: 60px; /* Adjust this if your NavBar changes height */
}

/* Fade transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease, transform 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

/* ----------------- MEDIA QUERIES ----------------- */

/* For phones and smaller tablets */
@media (max-width: 600px) {
  /* Reduce the top padding so content is more visible on small screens */
  .main-content {
    padding-top: 50px;
  }

  body {
    /* background-attachment: scroll for better performance on mobile */
    background-attachment: scroll;
    overflow-x: hidden;
  }

}
</style>
